import React from 'react';
import { getBackgroundClassName } from '../../../objects';
import { has } from '../../../services/classify';
import clsx from 'clsx';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
/**
 * Box Footer Component
 * @param className {string} Additionnal CSS Classes
 * @param children {React.ReactNode} Children
 * @param backgroundColor {TrilogyColor} Background for BoxFooter
 */
const BoxFooter = ({ className, children, backgroundColor, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    return (React.createElement("div", { "data-testid": testId, className: hashClass(styled, clsx('box-footer', backgroundColor && has(getBackgroundClassName(backgroundColor)), className)), ...others }, children));
};
export default BoxFooter;
//# sourceMappingURL=BoxFooter.js.map